import { NgModule } from "@angular/core";
import { CircleLinesLoaderComponent } from "./circle-lines-loader.component";
import { SearchLoaderComponent } from "./search-loader.comonent";

@NgModule({
  declarations: [SearchLoaderComponent, CircleLinesLoaderComponent],
  exports: [SearchLoaderComponent, CircleLinesLoaderComponent],
})
export class LoadersModule {}
